import React, { Component } from "react";
import { connect } from "react-redux";
import { isEmpty } from "lodash";
import {
  setUser,
  getRecentOrders,
  displayNotification,
} from "../../../store/actions";
import Box from "@material-ui/core/Box";
import Collapse from "@material-ui/core/Collapse";
import IconButton from "@material-ui/core/IconButton";
import Button from "@material-ui/core/Button";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import TablePagination from "@material-ui/core/TablePagination";
import TableFooter from "@material-ui/core/TableFooter";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import authService from "../../../../components/api-authorization/AuthorizeService";
import { FcCheckmark } from "react-icons/fc";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FcDownload } from "react-icons/fc";
import packageJson from "../../../../../../ClientApp/package.json";
import { loadingPage } from "../../../store/actions";
import Lottie from "react-lottie";
import animationData from "../../../../assets/lotties/loadLottie.json";

async function DownloadReport(orderNo) {
  const token = await authService.getAccessToken();

  let result = orderNo.replace("/", "-");

  const response = await fetch(
    "api/data/downloadorderacknowledgement/" + result,
    {
      method: "get",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    }
  );

  const data = await response.json();

  //console.log('result', data);

  if (data.isSuccess) {
    var sampleArr = base64ToArrayBuffer(data.base64FileData);
    saveByteArray(data.fileName, sampleArr);
  }
}

function base64ToArrayBuffer(base64) {
  var binaryString = window.atob(base64);
  var binaryLen = binaryString.length;
  var bytes = new Uint8Array(binaryLen);
  for (var i = 0; i < binaryLen; i++) {
    var ascii = binaryString.charCodeAt(i);
    bytes[i] = ascii;
  }
  return bytes;
}

function saveByteArray(reportName, byte) {
  var blob = new Blob([byte], { type: "application/pdf" });
  var link = document.createElement("a");
  var objectUrl = window.URL.createObjectURL(blob);
  link.href = objectUrl;
  var fileName = reportName;
  link.download = fileName;
  link.click();

  // Clean up the URL object
  window.URL.revokeObjectURL(objectUrl);
}

function Row(props) {
  const { row } = props;
  const [open, setOpen] = React.useState(false);

  return (
    <React.Fragment>
      <TableRow sx={{ "& > *": { borderBottom: "unset" } }}>
        <TableCell>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => setOpen(!open)}
          >
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        <TableCell component="th" scope="row">
          {row.orderNo}
        </TableCell>
        <TableCell>{row.cusOrderNo}</TableCell>
        <TableCell>{row.dateOrderedString}</TableCell>

        {row.despatched === false ? (
          <TableCell></TableCell>
        ) : (
          <TableCell>
            {" "}
            <FcCheckmark size={30}> </FcCheckmark>
          </TableCell>
        )}

        {row.paid === false ? (
          <TableCell></TableCell>
        ) : (
          <TableCell>
            {" "}
            <FcCheckmark size={30}> </FcCheckmark>
          </TableCell>
        )}

        <TableCell align="center">
          <Button color="primary" onClick={() => DownloadReport(row.orderNo)}>
            Download &nbsp;
            <FcDownload style={{ fontSize: "1.5em" }} />
          </Button>
        </TableCell>
      </TableRow>

      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box sx={{ margin: 1 }}>
              <Typography variant="h6" gutterBottom component="div">
                Order Details
              </Typography>
              <Table size="small" aria-label="purchases">
                <TableHead>
                  <TableRow>
                    <TableCell>Product</TableCell>
                    <TableCell>Qty&nbsp;Ordered</TableCell>
                    <TableCell>Qty&nbsp;Despatched</TableCell>
                    <TableCell>Depot</TableCell>
                    <TableCell>Req&nbsp;Del&nbsp;Date</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {row.orderItems.map((itemRow) => (
                    <TableRow key={itemRow.orderItemId}>
                      <TableCell component="th" scope="row">
                        {itemRow.productName}
                      </TableCell>
                      <TableCell>{itemRow.qtyOrdered}</TableCell>
                      <TableCell>{itemRow.qtyDespatched}</TableCell>
                      <TableCell>{itemRow.depot}</TableCell>
                      <TableCell>{itemRow.reqDelDateString}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}

const displayNote = (msg) =>
  toast.info(msg, {
    position: "top-right",
    autoClose: 7000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "colored",
  });

class OrderHistoryTable extends Component {
  state = {
    loading: false,
  };
  async CheckVersion() {
    try {
      const ver = packageJson.releaseVersionNo;
      const token = await authService.getAccessToken();

      const response = await fetch("api/data/getlatestversion/", {
        method: "post",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      const ret = await response.json();

      if (ver === ret.message) {
        if (isEmpty(this.props.user)) {
          //dont have user
          await this.populateState();
        } else {
          //found user
          await this.setState(
            { username: this.props.user.email, userSavedInStore: true },
            async () => {
              await this.GetRecentOrders();
            }
          );
        }

        //this.popUp();
      } else {
        window.location.reload();
      }
    } catch (e) {
    } finally {
    }
  }

  state = {
    username: "",
    userSavedInStore: false,
    page: 0,
    rowsPerPage: 10,
  };

  componentDidMount() {
    //get username and then pass username to api to get recent orders
    this.CheckVersion();
  }

  async popUp() {
    await this.props.displayNotification();
    displayNote(this.props.notificationText);
  }

  async populateState() {
    const [isAuthenticated, user] = await Promise.all([
      authService.isAuthenticated(),
      authService.getUser(),
    ]);

    this.setState(
      { username: user && user.name, userSavedInStore: false },
      async () => {
        await this.GetRecentOrders();
      }
    );
  }

  handleChangePage = (event, newPage) => {
    this.setState({ page: newPage });
  };

  handleChangeRowsPerPage = (event) => {
    this.setState({ rowsPerPage: +event.target.value });
    this.setState({ page: 0 });
  };

  async GetRecentOrders() {
    this.setState({ loading: true });
    await this.props.getRecentOrders(
      this.state.username,
      this.state.userSavedInStore
    );
    this.setState({ loading: false });
  }

  render() {
    return (
        <>
        <div>
        <ToastContainer
            position="bottom-right"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
        </div>
      
        {this.state.loading ? (
          <div>
            <Lottie
              options={{
                loop: true,
                autoplay: true,
                animationData: animationData,
                rendererSettings: {
                  preserveAspectRatio: "xMidYMid slice",
                },
              }}
              height={60}
              width={60}
            />
          </div>
        ) : (
          !isEmpty(this.props.orders) ? (
            <TableContainer component={Paper}>
                          <Table aria-label="collapsible table">
                            <TableHead style={{ backgroundColor: "ghostwhite" }}>
                              <TableRow>
                                <TableCell />
                                <TableCell>Order&nbsp;No</TableCell>
                                <TableCell>Cust&nbsp;Order&nbsp;No</TableCell>
                                <TableCell>Date&nbsp;Ordered</TableCell>
                                <TableCell>Despatched</TableCell>
                                <TableCell>Paid</TableCell>
                                <TableCell align="center"></TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {this.props.orders
                                .slice(
                                  this.state.page * this.state.rowsPerPage,
                                  this.state.page * this.state.rowsPerPage +
                                    this.state.rowsPerPage
                                )
                                .map((row) => (
                                  <Row key={row.orderId} row={row} />
                                ))}
                            </TableBody>
              
                            <TableFooter>
                              <TableRow>
                                <TablePagination
                                  rowsPerPageOptions={[10]}
                                  count={this.props.orders.length}
                                  rowsPerPage={this.state.rowsPerPage}
                                  page={this.state.page}
                                  onChangePage={this.handleChangePage}
                                  onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                />
                              </TableRow>
                            </TableFooter>
                          </Table>
                        </TableContainer>
          ) : (
            <p style={{ textAlign: "center" }}>No orders found</p>
          )
        )}
      </>
    ); 
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.userReducer.user,
    orders: state.orderHistory.orderList,
    notificationText: state.orderHistory.notificationText,
  };
};

export default connect(mapStateToProps, {
  setUser,
  getRecentOrders,
  displayNotification,
  loadingPage,
})(OrderHistoryTable);
